import React from 'react';
import { Box } from '@mui/material';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import colors from 'src/utils/colors';
import { EyeShow, EyeHide } from 'src/components/SvgIcons/SvgIcons';
import { SlButton } from 'src/components/BeaconV2Components/Header/SLDropdownMenu/SlButton';
import { useKeywordsDisplayStore } from 'src/components/BeaconV2Components/ExperimentalLayout/ContentGeneration/stores';

type LibraryReviewHeaderProps = { handleExport?: () => void; isExporting?: boolean };

export const LibraryReviewHeader: React.FC<LibraryReviewHeaderProps> = ({ handleExport, isExporting }) => {
  const { showKeywords, setShowKeywords } = useKeywordsDisplayStore();

  const handleToggleKeywords = () => {
    setShowKeywords(!showKeywords);
  };

  return (
    <Box sx={{ mb: '32px', position: 'relative' }}>
      {/* Header with action buttons */}
      <Flex
        alignItems="flex-start"
        justifyContent="space-between"
        gap={2}
        sx={{
          mb: 1,
          overflow: 'visible',
          height: '20px'
        }}
      >
        <Box>
          <Text
            variant="h3"
            fontWeight={700}
            sx={{
              color: colors.darkBlue,
              fontSize: '20px',
              lineHeight: '28px'
            }}
          >
            Content Review
          </Text>
        </Box>

        {/* Action buttons positioned on the right */}
        <Flex gap={16} alignItems="center">
          <SlButton
            startIcon={
              showKeywords ? (
                <EyeHide style={{ width: 16, height: 16, marginRight: 8 }} />
              ) : (
                <EyeShow style={{ width: 16, height: 16, marginRight: 8 }} />
              )
            }
            variant="normal"
            onClick={handleToggleKeywords}
            buttonSx={{
              paddingLeft: '8px',
              paddingRight: '12px'
            }}
          >
            <Text variant="body2" sx={{ color: colors.darkBlue, fontWeight: 500, fontSize: '14px' }}>
              {showKeywords ? 'Hide keywords' : 'Show keywords'}
            </Text>
          </SlButton>
          <SlButton variant="normal" onClick={() => handleExport?.()} disabled={isExporting || !handleExport}>
            {isExporting ? 'Exporting...' : 'Export'}
          </SlButton>
        </Flex>
      </Flex>

      {/* Subtext */}
      <Box sx={{ pr: 10 }}>
        <Text
          sx={{
            color: colors.darkBlue,
            fontSize: '16px',
            fontWeight: 400,
            lineHeight: '24px'
          }}
        >
          Review and compare all content versions for this product.
        </Text>
      </Box>
    </Box>
  );
};
